import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Domain, Domains, DomainDto } from '../../models/domain';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env';

/**
 * A stateless service responsible *only* for fetching and mutating
 * Operations and Subdomains data via HTTP or mocks.
 * It does not hold or manage any application state.
 */
@Injectable({
  providedIn: 'root',
})
export class DomainService {
  private readonly http = inject(HttpClient);

  getDomains(): Observable<Domains> {
    return this.http.get<Domains>(environment.apiPrefix + environment.domains);
  }

  addDomain(addDto: DomainDto): Observable<Domain> {
    const url = environment.apiPrefix + environment.domains;
    return this.http.post<Domain>(url, addDto);
  }

  editDomain(domainId: number, updateDto: DomainDto): Observable<Domain> {
    const url = `${environment.apiPrefix}${environment.domains}/${domainId}`;
    return this.http.put<Domain>(url, updateDto);
  }

  deleteDomain(domainId: number): Observable<any> {
    const url = `${environment.apiPrefix}/domains/${domainId}`;
    return this.http.delete(url);
  }

  updateDomainsOrder(domainIds: number[]): Observable<any> {
    const url = `${environment.apiPrefix}${environment.domains}/sorting`;
    return this.http.put(url, domainIds);
  }
}
